module.exports = __webpack_public_path__ + "img/sprites.e63c308.webp";